export default __webpack_public_path__ + "static/media/expand-collapse.e04fe96d.svg";